import { render, staticRenderFns } from "./GestionEspace.vue?vue&type=template&id=65c3ff55"
import script from "./GestionEspace.vue?vue&type=script&lang=js"
export * from "./GestionEspace.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports